var map = {
	"./failed.svg": "2369",
	"./file.svg": "1b44",
	"./no-data.svg": "d764",
	"./no-filter.svg": "49d7",
	"./search.svg": "ada24",
	"./success.svg": "223a",
	"./uploading.svg": "53c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2c43";